<template>
    <div id="DpSetDestination">
        <div class="px-3">
            <p class="pa-2 headline">お届け先を教えてください</p>
            <v-form ref="destination">
            <v-text-field
                    label="お名前"
                    v-model="customer.name"
                    :rules="[rules.required]"
                    outline
            ></v-text-field>
            <v-text-field
                    label="Email"
                    v-model="customer.email"
                    :rules="[rules.required, rules.email]"
                    outline
                    type="email"
            ></v-text-field>
            <v-text-field
                    label="電話番号"
                    v-model="customer.tel"
                    outline
                    type="tel"
                    :rules="[rules.required,rules.phone]"
            ></v-text-field>

                <v-text-field
                        label="お届け先郵便番号"
                        v-model="customer.zip"
                        outline
                        maxlength="7"
                        :rules="[rules.required, rules.zipcode]"
                        type="tel"
                ></v-text-field>

                <v-textarea
                        label="お届け先住所"
                        v-model="customer.address"
                        outline
                        :rules="[rules.required]"
                        rows="2"
                        placeholder="沖縄県那覇市久茂地2-2-2タイムスビル2F Howlive内"
                ></v-textarea>

            <v-btn color="orange" block
                   @click.prevent="goSetGps"
                   :loading="phoneVerifying"

            >
                お届け先の地図指定へ
            </v-btn>

                <v-checkbox
                        v-model="keepLocalData"
                        label="端末に入力データを保存しない場合はオフにしてください。"
                ></v-checkbox>

            </v-form>

        </div>

        <v-dialog
                v-model="phoneVerificationDialog"
                persistent
        >
            <v-card class="pa-3">
                <h3>電話番号を確認させてください</h3>
                <p>以下のボタンを押すと、システムが電話をかけて、確認番号を音声でお伝えします。発信元電話番号は050-3184-1777です。</p>
                この番号に電話をかけます: <span class="font-weight-bold">{{userSelect.tel}}</span>
                <v-btn color="orange" block
                       @click.prevent="startRing"
                       :loading="callinitiaing"
                >
                    電話をかける
                </v-btn>
                <p class="text-xs-center mt-4 mb-1">
                    <a
                            @click.prevent="phoneVerificationDialog = false"
                    >
                        やめる/電話番号を再入力する
                    </a>
                </p>

            </v-card>

        </v-dialog>


        <v-dialog
                v-model="inputSmsCodeDialog"
                persistent
        >
            <v-card class="pa-3" color="yellow">
                <h3>SMSで確認コードをお送りしています。</h3>
                <p>{{callProgress.text}}</p>
                <p>発信元電話番号は+19093774777(米国からの発信)です。SMS(メッセージ)アプリで番号を確認してください。</p>

                <div v-if="!sendVerifyNumberDisabled">
                    <v-text-field
                            label="確認番号"
                            v-model="smsVerificationNumber"
                            ref="smsVerificationNumber"
                            outline
                            :rules="[rules.required,rules.verificationNumber]"
                            inputmode="numeric"
                            type="text"
                            autocomplete="one-time-code"
                    ></v-text-field>

                    <v-btn color="orange" block
                           @click.prevent="sendSmsVerifyNumber"
                           :loading="confirmingVerificationNumber"
                    >
                        確認しました
                    </v-btn>
                </div>

                <div v-if="sendVerifyNumberDisabled">
                    <p class="text-xs-center">{{callProgress.text}}</p>
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                </div>

                {{verificationResult}}
                <p class="text-xs-center mt-4 mb-1">
                    <a
                            @click.prevent="inputSmsCodeDialog = false"
                    >
                        やめる/電話番号を再入力する
                    </a>
                </p>
                <p class="text-xs-center mt-4 mb-1">
                    <a
                            @click.prevent="sendVerifyNumberDisabled = true"
                    >
                        番号入力欄を表示する
                    </a>
                </p>
                <p class="text-xs-center mt-4 mb-1">
                    <a
                            @click.prevent="closeSmsOpenPhone"
                    >
                        SMSが届かない/音声で確認番号を聞く
                    </a>
                </p>

            </v-card>

        </v-dialog>


        <v-dialog
                v-model="inputPhoneVerificationDialog"
                persistent
        >
            <v-card class="pa-3" color="yellow">
                <h3>電話をとって、音声を聞いてください。</h3>
                <p>{{callProgress.text}}</p>
                <p>発信元電話番号は050-3184-1777です。システムが確認番号を言いますので、入力してください。</p>

                <v-text-field
                        label="確認番号"
                        v-model="verificationNumber"
                        ref="verificationNumber"
                        outline
                        type="tel"
                        :rules="[rules.required,rules.verificationNumber]"
                        :disabled="sendVerifyNumberDisabled"
                ></v-text-field>

                <v-btn color="orange" block
                       @click.prevent="sendVerifyNumber"
                       :disabled="sendVerifyNumberDisabled"
                       :loading="confirmingVerificationNumber"

                >
                    確認しました
                </v-btn>
                {{verificationResult}}
                <p class="text-xs-center mt-4 mb-1">
                    <a
                            @click.prevent="inputPhoneVerificationDialog = false"
                    >
                        やめる/電話番号を再入力する
                    </a>
                </p>

            </v-card>

        </v-dialog>

    </div>
</template>
<script>
import  { Logger,Auth } from 'aws-amplify';
const logger = new Logger('DpSetCust','INFO');
import { AmplifyEventBus } from 'aws-amplify-vue'
export default {
    //
    // This page is navigated by beforeEnter at router.js
    //
    data() {
        return {
            keepLocalData:true,
            phoneVerificationDialog:false,
            cognitoIdentity:undefined,
            phoneVerifying:false,
            callinitiaing:false,
            inputPhoneVerificationDialog:false,
            verificationNumber:"",
            confirmingVerificationNumber:false,
            currentCallSid:undefined,
            callProgress:{},
            verificationResult:"",
            sendVerifyNumberDisabled:true,
            inputSmsCodeDialog:false,
            smsVerificationNumber:"",
            rules:{
                required: value => !!value || '必ず入力してください。',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'メールアドレスが正しくありません。'
                },
                zipcode: value => {
                    const pattern = /[0-9]{7}/
                    return pattern.test(value) || '7桁の半角数字(ハイフンなし)で入力してください。'
                },
                phone:value => {
                    const pattern = /^0[0-9]{9,}/
                    return pattern.test(value) || '0から始まる半角数字(ハイフンなし)で入力してください。'
                },
                verificationNumber:value => {
                    const pattern = /^[0-9]{4}/
                    return pattern.test(value) || '半角数字(ハイフンなし)4桁で入力してください。'
                }
            },
        }
    },
    created() {
        AmplifyEventBus.$on("mqttMessage",this.mqttMessageReceived)
    },
    beforeDestroy() {
        logger.info("DpSetDest beforeDestroy")
        AmplifyEventBus.$off("mqttMessage",this.mqttMessageReceived)

    },
    async mounted() {
        logger.info("DpSetDest")
        AmplifyEventBus.$emit('setBackTo', "/dpConsent")
        const anonymousUser = await Auth.currentCredentials()
        this.cognitoIdentity = anonymousUser.identityId
        //reset userSelect
        this.userSelect = {}

    },
    methods:{
        closeSmsOpenPhone:async function(){
            this.inputSmsCodeDialog = false
            this.inputPhoneVerificationDialog = true
        },
        sendVerifyNumber:async function(){
            this.confirmingVerificationNumber = true
            const validationResult = this.$refs.verificationNumber.validate()
            logger.info("sendVerifyNumber",validationResult)
            if(validationResult){
                this.callinitiaing = true
                const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/checkPhone"
                const dataToSend = {}
                dataToSend.request = "confirmNumber"
                dataToSend.premiseId = this.$store.state.placeIdParam
                dataToSend.hostname = location.hostname
                dataToSend.cognitoId = this.cognitoIdentity
                dataToSend.email = this.customer.email
                dataToSend.tel = this.customer.tel
                dataToSend.name = this.customer.name
                dataToSend.pin = this.verificationNumber
                logger.info("confirmNumber dataToSend",dataToSend)
                const res = await this.axios.post(apiUrl,dataToSend)
                logger.info("confirmNumber res",res.data)
                if(res.data.isSuccess && res.data.verified){
                    logger.info("matched and verified")
                    this.$set(this.userSelect,"phoneVerified",true)
                    this.$router.push("/dpSetGps")
                }else{
                    alert("番号が一致しません。再度、入力してください。")
                }
            }
            this.confirmingVerificationNumber = false
        },
        sendSmsVerifyNumber:async function(){
            this.confirmingVerificationNumber = true
            const validationResult = this.$refs.smsVerificationNumber.validate()
            logger.info("sendVerifyNumber",validationResult)
            if(validationResult){
                this.callinitiaing = true
                const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/checkPhone"
                const dataToSend = {}
                dataToSend.request = "confirmNumber"
                dataToSend.premiseId = this.$store.state.placeIdParam
                dataToSend.hostname = location.hostname
                dataToSend.cognitoId = this.cognitoIdentity
                dataToSend.email = this.customer.email
                dataToSend.tel = this.customer.tel
                dataToSend.name = this.customer.name
                dataToSend.pin = this.smsVerificationNumber
                logger.info("confirmNumber dataToSend",dataToSend)
                const res = await this.axios.post(apiUrl,dataToSend)
                logger.info("confirmNumber res",res.data)
                if(res.data.isSuccess && res.data.verified){
                    logger.info("matched and verified")
                    this.$set(this.userSelect,"phoneVerified",true)
                    this.$router.push("/dpSetGps")
                }else{
                    alert("番号が一致しません。再度、入力してください。")
                }
            }
            this.confirmingVerificationNumber = false
        },
        mqttMessageReceived:function(data){
            if(data.callSid == this.currentCallSid){
                logger.info("message for this callSid",data)
                const callStatus = {status:data.result}
                switch(data.result){
                    case "initiated":
                        callStatus.text = "電話をかけています..."
                        break
                    case "ringing":
                        callStatus.text = "お呼び出し中です..."
                        break
                    case "answered":
                        callStatus.text = "応答がありました"
                        this.sendVerifyNumberDisabled = false
                        break
                    case "completed":
                        callStatus.text = "通話を終了しました"
                        this.sendVerifyNumberDisabled = false
                        break
                    case "in-progress":
                        callStatus.text = "通話中です"
                        this.sendVerifyNumberDisabled = false
                        break
                    case "busy":
                        callStatus.text = "お話し中で接続できません"
                        break
                    case "failed":
                        callStatus.text = "通話に失敗しました"
                        break
                    case "no-answer":
                        callStatus.text = "応答がありませんでした"
                        break
                    //sms
                    case "sent":
                        callStatus.text = "SMSを送信中です"
                        break
                    case "delivered":
                        callStatus.text = "送信しました"
                        this.sendVerifyNumberDisabled = false
                        break
                    case "queued":
                        callStatus.text = "送信準備中です"
                        break
                    case "undelivered":
                        callStatus.text = "送信に失敗しました"
                        break
                    default:
                        callStatus.text = data.result
                }
                this.callProgress = callStatus
            }
        },
        startRing:async function(){
            this.callinitiaing = true
            const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/checkPhone"
            const dataToSend = {}
            dataToSend.request = "ring"
            dataToSend.premiseId = this.$store.state.placeIdParam
            dataToSend.hostname = location.hostname
            dataToSend.cognitoId = this.cognitoIdentity
            dataToSend.email = this.customer.email
            dataToSend.tel = this.customer.tel
            dataToSend.name = this.customer.name
            logger.info("startRing dataToSend",dataToSend)
            const res = await this.axios.post(apiUrl,dataToSend)
            logger.info("startRing res",res.data)
            this.callinitiaing = false
            if(res.data.isSuccess){
                this.inputPhoneVerificationDialog = true
                this.phoneVerificationDialog = false
                this.currentCallSid = res.data.callSid
            }
        },
        goSetGps:async function(){
            this.phoneVerifying = true
            // validation
            if(this.$refs.destination.validate()){
                const toUserSelect = {}
                for(let i in this.customer){
                    if(i != "keepLocalData"){
                        toUserSelect[i] = this.customer[i]
                    }
                }
                this.userSelect = toUserSelect


            }else{
                alert("未入力の項目または入力内容に誤りがあります。再度、ご確認ください。")
                this.phoneVerifying = false
                return
            }
            // delete if customer checkbox off
            if(!this.keepLocalData){
                this.customer = {}
            }
            // phone number validation
            const phoneValidationResult = await this.checkPhoneNumber()
            if(phoneValidationResult.verified){
                logger.info("matched and verified")
                this.$set(this.userSelect,"phoneVerified",true)
                this.$router.push("/dpSetGps")
            }else{
                this.callinitiaing = false
                if(phoneValidationResult.reason == "not a mobile number"){
                    this.phoneVerificationDialog = true
                }else{
                    this.currentCallSid = phoneValidationResult.callSid
                    this.inputSmsCodeDialog = true
                }

            }
            this.phoneVerifying = false
        },
        checkPhoneNumber:async function(){

            const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/checkPhone"
            const dataToSend = {}
            dataToSend.request = "verify"
            dataToSend.premiseId = this.$store.state.placeIdParam
            dataToSend.hostname = location.hostname
            dataToSend.cognitoId = this.cognitoIdentity
            dataToSend.email = this.customer.email
            dataToSend.tel = this.customer.tel
            dataToSend.name = this.customer.name
            logger.info("checkPhone dataToSend",dataToSend)
            const res = await this.axios.post(apiUrl,dataToSend)
            logger.info("checkPhone res",res.data)
            return res.data
        }
    },
    computed: {
        customer: {
            get() {
                return this.$store.state.customer
            },
            set(value) {
                this.$store.commit('setCustomerMT', value)
            }

        },
        userSelect:{
            get() {
                return this.$store.state.userSelect
            },
            set(value) {
                this.$store.commit('setUserSelectMT', value)
            }

        },
        deliveryProvider: {
            get() {
                return this.$store.state.deliveryProvider
            },
            set(value) {
                this.$store.commit("setDeliveryProviderMT", value)
            }
        },
    },
    watch:{
        verificationNumber:function(val){
            if(val.length == 4
                && this.$refs.verificationNumber.validate()){
                this.sendVerifyNumberDisabled = false
                this.sendVerifyNumber()
            }
        },
        smsVerificationNumber:function(val){
            if(val.length == 4
                && this.$refs.smsVerificationNumber.validate()){
                this.sendVerifyNumberDisabled = false
                this.sendSmsVerifyNumber()
            }
        }
    }
}

</script>
<style>
    .theme--light.v-text-field--outline > .v-input__control > .v-input__slot{
        background-color: white !important;
    }
</style>